<div class="dashboard-tile">
  <div class="tile-header">
    <div class="tile-header-title">{{selectedNistFunctionName}} - {{selectedNistSubCategoryName}}</div>
  </div>
  <div class="tile-content">
    <ng-container *ngFor="let question of questionData">
      <div fxLayout="column" fxLayoutAlign="start stretch">
        <span class="question-title bg-primary-shade">Q: {{question.text}}</span>
        <div fxLayout="column" *ngFor="let answer of question.answers">
          <ng-container>
            <span class="question-answer">A: {{answer.text}}</span>
            <span *ngIf="answer.impactDescription" class="question-positive"><b>Importance:</b> {{answer.impactDescription}}</span>
            <span *ngIf="answer.remediationSteps" class="question-positive"><b>Remediation Steps:</b> {{answer.remediationSteps}}</span>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
